export function preventTyping(e) {
    e.preventDefault()
    return false
}
